const topics = [

    {
      title: "Ancient China",
      slug: "ancientchina",
      standardNumber: "3.2",
      description: "Geography – The student will apply history and social science skills to locate and describe major geographic features of the continents and hemispheres.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fancientchina2025video.mp4?alt=media&token=96c70129-913b-43ce-a8a2-1de2230cb374",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fancientchina2025song.mp3?alt=media&token=33ed2a4f-c475-4244-9d7e-9d9e9904fa62",
      lyrics: ["(Chorus)",
"Ancient China long ago, long ago, long ago,",
"Ancient China long ago, long ago, long ago,",
"Ancient China long ago, long ago, long ago,",
"Ancient China long ago, long ago, long ago.",

"(Verse)",
"Ancient China, part of Asia,",
"Symbols and characters were their written language.",
"The ancient climate had four seasons,",
"Summer, winter, spring, and fall, feel the breeze.",
"Ancient China formed different types of lands,",
"They had forests, hills, deserts, and mountains.",
"Ancient China at the Huang He River,",
"They used the river for irrigation and farming.",
"Ancient China gave us kites,",
"They gave us fireworks to brighten up the night.",
"Gave us the compass, directions we will find them,",
"They also built the Great Wall of China.",

"(Chorus)",
"Ancient China long ago, long ago, long ago,",
"Ancient China long ago, long ago, long ago,",
"Ancient China long ago, long ago, long ago,",
"Ancient China long ago, long ago, long ago.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Ancient Egypt",
      slug: "ancientegypt",
      standardNumber: "3.2",
      description: "Geography – The student will apply history and social science skills to locate and describe major geographic features of the continents and hemispheres.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fancientegypt2025video.mp4?alt=media&token=f82cc173-449a-45d3-acf8-d8a9b97b7dfb",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fancientegypt2025song.mp3?alt=media&token=43189d8f-3f45-4b26-aa9d-020b273602bf",
      lyrics: ["(chorus)",
        "Living in the desert we get hot, in ancient Egypt.",
        "Living in the desert we get hot, in ancient Egypt.",
        "Living in the desert we get hot, in ancient Egypt.",
        "Living in the desert we get, living in the desert we get hot.",
        "(verse)",
        "Ancient Egypt is part of Africa.",
        "Water for farming came from the Nile River.",
        "Ancient Egypt climate: hot and dry,",
        "the weather over a long period of time.",
        "Ancient Egyptians wrote in hieroglyphics.",
        "Ancient Egyptians built big pyramids.",
        "Ancient Egyptians made clocks and calendars.",
        "So, ancient means: a long, long time ago.",
        "(chorus)",
        "Living in the desert we get hot, in ancient Egypt.",
        "Living in the desert we get hot, in ancient Egypt.",
        "Living in the desert we get hot, in ancient Egypt.",
        "Living in the desert we get, living in the desert we get hot.",
        "© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "They Built",
      slug: "theybuilt",
      standardNumber: "3.3",
      description: "Geography – The student will apply history and social science skills to describe major geographic features of ancient societies on a world map.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftheybuilt2025video.mp4?alt=media&token=f9c89ace-2b43-4311-9447-7078402685fb",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftheybuilt2025song.mp3?alt=media&token=e017fb9c-7e1f-4a7d-9e2a-1e5c31dd76ef",
      lyrics: ["(verse)",
        "In Ancient Greece the architects built columns and the Parthenon.",
        "In Ancient Greece the architects built columns and the Parthenon.",
        "In Ancient Rome the architects built arches and aqueducts.",
        "In Ancient Rome the architects built the Coliseum.",
        "In Ancient Greece people were farmers, traders, and they built ships.",
        "In Ancient Rome people were farmers, traders, and they built roads.",
       
        "© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Ancient Greece",
      slug: "ancientgreece",
      standardNumber: "3.3",
      description: "Geography – The student will apply history and social science skills to describe major geographic features of ancient societies on a world map.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fancientgreece2025video.mp4?alt=media&token=172d2e75-0052-4d51-9c67-33a08c364200",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fancientgreece2025song.mp3?alt=media&token=f801a467-e041-4093-a397-8bf85b2e4e47",
      lyrics: ["(chorus)",
"In Ancient Greece we wear chiton,",
"that was the clothing.",
"In Ancient Greece we hear myths,",
"those were the stories.",
"In Ancient Greece we traded",
"wheat, barley, fish, olives and grapes,",
"olives and grapes.",

"(verse)",
"Ancient Greece had hills and mountains,",
"and the soil was poor.",
"A peninsula on the Mediterranean Sea in Europe.",
"The Greeks were farmers, shipbuilders, and traders.",
"The Greeks had marketplaces that were called agoras.",
"In Ancient Greece was a city called Athens.",
"Athens was known for its education and learning.",
"In Ancient Greece was a city called Sparta.",
"Sparta was known for the strength of its army.",
"In Athens, they build the Parthenon as the main temple.",
"It has rows of columns that are beautiful and not simple.",
"The Olympic Games started in Ancient Greece",
"on Mount Olympus, so they named it The Olympics.",
"The Ancient Greece government was a democratic government.",
"The birthplace of democracy. Power to the people.",

"(chorus)",
"In Ancient Greece we wear chiton,",
"that was the clothing.",
"In Ancient Greece we hear myths,",
"those were the stories.",
"In Ancient Greece we traded",
"wheat, barley, fish, olives and grapes,",
"olives and grapes.",

"© Smart Board Learning, LLC. All rights reserved.",
],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Ancient Rome",
      slug: "ancientrome",
      standardNumber: "3.3",
      description: "Geography – The student will apply history and social science skills to describe major geographic features of ancient societies on a world map.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fancientrome2025video.mp4?alt=media&token=080750b5-dbca-45e6-9ade-d0da0b9d5b8c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fancientrome.mp3?alt=media&token=a1380bfa-c7ab-4d67-80ac-58e82b7ea622",
      lyrics: ["(chorus)",
"Rome today is in the country of Italy.",
"Rome today is in the country of Italy.",
"Rome today is in the country of Italy.",
"Rome today is in the country of Italy.",

"(verse)",
"Ancient Rome was part of Europe, Africa, and Asia.",
"Ancient Rome, it was called an empire.",
"Ancient Rome, only one place it can be,",
"located next to the Mediterranean Sea.",
"Ancient Rome, the soil was rocky.",
"Ancient Rome had many different types of trees.",
"Ancient Romans specialized in building.",
"Ancient Romans specialized in fishing and trading.",
"Ancient Romans built roads and ships.",
"They also built the Colosseum where they had events.",
"Ancient Romans had a democratic government.",
"A government in which people voted for representatives.",
"Ancient Romans built aqueducts to bring water to cities.",

"(chorus)",
"Rome today is in the country of Italy.",
"Rome today is in the country of Italy.",
"Rome today is in the country of Italy.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Mali",
      slug: "mali",
      standardNumber: "3.4",
      description: "History – The student will apply history and social science skills to describe the geographic, political, economic, and social structures and innovations of ancient Egypt.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmali2025video.mp4?alt=media&token=dbc626ad-7768-4e13-a67e-ae199def1da7",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmali2025song.mp3?alt=media&token=80b079f3-855e-4bc5-ba62-191c39c32cc8",
      lyrics: ["(chorus)",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",

"(verse 1)",
"Mali was an important trade center.",
"Mali was an important trade center.",
"The kings of Mali were wealthy, were wealthy.",
"The kings of Mali were wealthy, were wealthy.",
"Mali was in between the salt in the Sahara",
"and the gold mines of West Africa.",
"Mali was in between the salt in the Sahara",
"and the gold mines of West Africa.",

"(chorus)",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",

"(verse 2)",
"The salt was traded for gold, for gold.",
"The salt was traded for gold, for gold.",
"Timbuktu was an important city in Mali.",
"Timbuktu was an important city in Mali.",

"(chorus)",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",
"Mali was a great empire in West Africa,",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },

    {
      title: "North America Features",
      slug: "northamericafeatures",
      standardNumber: "3.6",
      description: "History – The student will apply history and social science skills to describe the geographic, political, economic, and social structures and innovations of ancient Greece.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnorthamericafeatures2025video.mp4?alt=media&token=8f3c9230-48dc-4d72-9b25-aab2182f02fb",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnorthamericafeatures2025song.mp3?alt=media&token=830c7246-c02d-4475-bd37-31246353af5b",
      lyrics: ["(chorus)",
"North America, sing with me.",
"Mountains, rivers, lakes to see!",
"North America, clap along.",
"Let’s learn its features in our song!",

"(verse)",
"The Mississippi River flows to Gulf of Mexico.",
"The Saint Lawrence River connects the Great Lakes to the Atlantic Ocean.",
"The Appalachian Mountains are rounded mountains.",
"The Grand Canyon was carved by the Colorado River.",

"(chorus)",
"North America, sing with me.",
"Mountains, rivers, lakes to see!",
"North America, clap along.",
"Let’s learn its features in our song!",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Africa Features",
      slug: "africafeatures",
      standardNumber: "3.6",
      description: "History – The student will apply history and social science skills to describe the geographic, political, economic, and social structures and innovations of ancient Greece.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fafricafeatures2025video.mp4?alt=media&token=34fb20ed-11a8-4ba9-aa3a-e7acdce552fd",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fafricafeatures2025song.mp3?alt=media&token=c7b26aff-b651-426f-a3ad-80472cac2568",
      lyrics: ["(chorus)",
"Africa, Africa, let’s explore the land!",
"Rivers, mountains, deserts, all so grand.",
"Africa, Africa, come and sing with me.",
"Learning all its features, 1-2-3!",

"(verse)",
"The Nile River flows so wide.",
"The longest river in the world, a mighty ride.",
"Atlas Mountains stand so tall,",
"located in northwest Africa.",
"The Sahara Desert, hot and wide,",
"the largest desert on Earth’s great side.",
"Mount Kilimanjaro is the tallest in Africa.",
"The Congo River flows through the rainforest.",

"(chorus)",
"Africa, Africa, let’s explore the land!",
"Rivers, mountains, deserts, all so grand.",
"Africa, Africa, come and sing with me.",
"Learning all its features, 1-2-3!",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Europe Features",
      slug: "europefeatures",
      standardNumber: "3.6",
      description: "History – The student will apply history and social science skills to describe the geographic, political, economic, and social structures and innovations of ancient Greece.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Feuropefeatures2025video.mp4?alt=media&token=0c703920-c654-4a95-92b8-6d20aad04eb6",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Feuropefeatures2025song.mp3?alt=media&token=f754f620-596b-4350-aaab-ae8a24658e46",
      lyrics: ["(chorus)",
"Europe, Europe, come and see.",
"Its rivers, mountains, land, and sea!",
"Europe, Europe, sing along.",
"Let’s learn its features in our song!",

"(verse)",
"The Mediterranean Sea is important for trade.",
"The Mediterranean Sea makes great waves.",
"The Alps are mountains, tall and wide.",
"They're the biggest mountains in Europe, on the inside.",
"The Rhine River is important for trade.",
"The Volga River is the longest in Europe.",
"The Danube River flows through many countries.",
"The Danube River flows through many countries.",

"(chorus)",
"Europe, Europe, come and see.",
"Its rivers, mountains, land, and sea!",
"Europe, Europe, sing along.",
"Let’s learn its features in our song!",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "South America Features",
      slug: "southamericafeatures",
      standardNumber: "3.6",
      description: "History – The student will apply history and social science skills to describe the geographic, political, economic, and social structures and innovations of ancient Greece.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsouthamericafeatures2025video.mp4?alt=media&token=8ab05a3e-75bb-4c81-948b-e639cc1e5af9",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsouthamericafeatures2025song.mp3?alt=media&token=687cb38e-320e-4098-b0fa-7de0a8bf5d2a",
      lyrics: ["(chorus)",
"South America, come along.",
"Rivers, mountains, forests strong!",
"South America, sing with me.",
"Learning features, 1-2-3!",

"(verse)",
"The Amazon River flows so long.",
"The second longest river in the world, it’s strong.",
"The Andes Mountains stretch across the land.",
"The longest mountains, tall and grand.",
"The Amazon Rainforest is the largest forest,",
"with plants and animals for all of us.",

"(chorus)",
"South America, come along.",
"Rivers, mountains, forests strong!",
"South America, sing with me.",
"Learning features, 1-2-3!",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Producer",
      slug: "producer",
      standardNumber: "3.8",
      description: "History – The student will apply history and social science skills to describe the geographic, political, economic, and social structures and innovations of the ancient empire of Mali.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fproducer2025video.mp4?alt=media&token=927f12da-8625-49c4-9b45-c6dc89b4ae06",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fproducer2025song.mp3?alt=media&token=9907f02f-44ae-4bdc-a63d-241c0140ca0d",
      lyrics: ["(verse)",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"When resources are scarce, that means limited resources,",
"limited resources.",
"When resources are scarce, that means limited resources,",
"limited resources.",

"© Smart Board Learning, LLC. All rights reserved."],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Trade",
      slug: "trade",
      standardNumber: "3.9",
      description: "History – The student will apply history and social science skills to explain the basic structure of the United States government.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftradevideo2025old.mp4?alt=media&token=6dd9b138-4f02-42ee-9b97-3f804e60f7d7",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftrade.mp3?alt=media&token=aa09d2a5-dedd-482a-aec6-e7c941b09d6e",
      lyrics: ["(verse)",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",
"They trade with others to get what they don’t have.",
"They trade with others to get what they don’t have.",
"They trade with others to get what they don’t have.",
"They trade with others to get what they don’t have.",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Wants & Choices",
      slug: "wantsandchoices",
      standardNumber: "3.10",
      description: "Economics – The student will apply history and social science skills to explain basic economic principles.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwantsandchoices2025video.mp4?alt=media&token=46126733-76e4-468d-8dfd-2b3605f22776",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwantsandchoices2025song.mp3?alt=media&token=0cab7c9d-c510-4459-8e07-bd57a18920e6",
      lyrics: ["(Verse)",
"Things that we would like to have are called wants.",
"That’s what we want.",
"We can choose between two or more things, that’s a choice.",
"We have a choice.",
"Some choices that we make are made because we can’t have everything we want,",
"we want.",

"Things that we would like to have are called wants.",
"That’s what we want.",
"We can choose between two or more things, that’s a choice.",
"We have a choice.",
"Some choices that we make are made because we can’t have everything we want,",
"we want.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Responsible Citizen",
      slug: "responsiblecitizen",
      standardNumber: "3.11",
      description: "Civics – The student will apply history and social science skills to define citizenship and explain the rights and responsibilities of United States citizenship.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fresponsiblecitizen2025video.mp4?alt=media&token=c686e9e2-9c58-4d29-88ac-75835950a857",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fresponsiblecitizen2025song.mp3?alt=media&token=4fe0f14e-695b-4155-8ad4-696cbe08b452",
      lyrics: ["(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"(Verse)",
"Responsible citizens have civic duties.",
"Responsible citizens obey laws.",
"Responsible citizens serve on a jury,",
"Or as a witness, if they are called.",
"Responsible citizens have civic duties.",
"Responsible citizens pay their taxes.",
"Responsible citizens serve in the armed forces,",
"If they are called.",

"(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    }, 
    {
      title: "The Government",
      slug: "thegovernment",
      standardNumber: "3.12",
      description: "Civics – The student will apply history and social science skills to explain the basic structure of the United States government.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthegovernmentvideo2025old.mp4?alt=media&token=d00d2200-0963-42d4-a6e6-c83a60a4c5e1",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthegovernment.mp3?alt=media&token=34f24faf-493f-44b6-bf3b-13b82cd6d489",
      lyrics: ["(chorus)",
"Governments make laws to protect the",
"rights and the property of everyone.",
"Governments make laws to protect the",
"rights and the property of everyone.",

"(verse)",
"Laws are made to keep people safe.",
"Laws are made to keep people safe.",
"Laws are made so order can be maintained.",
"Laws are made so order can be maintained.",
"The job of the government is to make laws.",
"The job of the government is to carry out laws.",
"The job of the government is to decide if laws have been broken.",

"(chorus)",
"Governments make laws to protect the",
"rights and the property of everyone.",
"Governments make laws to protect the",
"rights and the property of everyone.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "As Americans",
      slug: "asamericans",
      standardNumber: "3.13",
      description: "Civics – The student will apply history and social science skills to define citizenship and explain the rights and responsibilities of United States citizenship.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fasamericansvideo.mp4?alt=media&token=061bf961-6f30-4193-a2a9-57d0c4945357",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fasamericanssong.mp3?alt=media&token=3dac71a2-2944-49e6-94c5-125abbf4c845",
      lyrics: ["(chorus)",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty…",
        "(verse)",
        "We the American people come from many different ethnic origins.",
        "We the American people come from many different countries.",
        "The republican form of government principles unites us as Americans.",
        "The republican form of government principles unites us as Americans.",
        "(chorus)",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    }, 
  
];
export default topics;